(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.sf-cart-form').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const variant = form.querySelector('[data-base-variant]');
      const button = form.querySelector('[data-submit]');
      const buttonContents = [...button.childNodes].map(node => node.cloneNode(true));
      const status = form.querySelector('.sf-cart-status');
      const addOns = [...form.querySelectorAll('[data-addon]')];
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: form.dataset.currency || 'INR', maximumFractionDigits: 2
      });
      const update = () => {
        const selected = variant.selectedOptions[0];
        let amount = Number(selected?.dataset.price || 0);
        addOns.forEach(input => { if (input.checked && !input.disabled) amount += Number(input.dataset.price); });
        const unknown = form.dataset.demo && addOns.some(input => input.checked && input.value === 'demo-negotiator');
        form.querySelector('[data-total]').textContent = money.format(amount / 100) + (unknown ? ' + negotiator' : '');
        form.querySelector('[data-base-price]').textContent = selected?.dataset.money || '';
        button.disabled = selected?.dataset.available !== 'true';
      };
      form.addEventListener('change', update);
      update();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled || form.dataset.pending) return;
        const items = [{ id: variant.value, quantity: 1 }];
        addOns.forEach(input => { if (input.checked && !input.disabled) items.push({ id: input.value, quantity: 1, ...(input.value === '67648529039659' ? { properties: { 'Pre-order': 'Ships separately on 1 November 2026' } } : {}) }); });
        if (form.dataset.demo) {
          const dialog = document.querySelector('.sf-demo-dialog');
          dialog.querySelector('[data-demo-summary]').textContent = items.map(item => ({'demo-sofi':'SOFI brewer', 'demo-holder':'Holder', 'demo-negotiator':'Negotiator (price to be confirmed)'})[item.id]).join(' + ');
          dialog.showModal();
          return;
        }
        form.dataset.pending = 'true';
        button.disabled = true;
        button.textContent = form.dataset.addingLabel;
        status.textContent = '';
        const recovery = form.querySelector('.sf-cart-recovery');
        recovery.hidden = true;
        try {
          const response = await fetch(form.action + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }), credentials: 'same-origin'
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.dataset.errorLabel);
          window.location.assign(form.dataset.cartUrl);
        } catch (error) {
          status.textContent = error.message === 'Failed to fetch' ? form.dataset.errorLabel : error.message;
          recovery.hidden = false;
          delete form.dataset.pending;
          button.replaceChildren(...buttonContents.map(node => node.cloneNode(true)));
          update();
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
